import { PACKAGE_AND_ZIP_DOWNLOAD, PACKAGE_AND_ZIP_DOWNLOAD_FULFILLED } from "@actions/download_link/"
import { POST_DEFAULTS } from "@constants"
import { GLOBALS } from "@src/config"

export const packageAndZipDownload = (projectID, files) => dispatch => {
    dispatch({
        type: PACKAGE_AND_ZIP_DOWNLOAD,
        files
    })

    fetch(`${GLOBALS.API_URL}/projects/${projectID}/packages/zip`, {
        ...POST_DEFAULTS,
        body: JSON.stringify({
            files
        })
    })
        .then(res => {
            if (res.ok) {
                return res.json()
            }
            throw new Error(`HTTP error! Status: ${res.status}`);
        })
        .then(json => {
            // call zip downloader service
            const link = document.createElement('a');
            link.href = json.zipUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            dispatch({
                type: PACKAGE_AND_ZIP_DOWNLOAD_FULFILLED,
                payload: {
                    packageUUID: json.packageUUID
                }
            })
        })
        .catch((error) => console.error(error)) // cors or network
}

export const sharedPackageAndZipDownload = (packageUUID, onError) => {
  fetch(`${GLOBALS.API_URL}/downloads/`, {
    ...POST_DEFAULTS,
    body: JSON.stringify({
      method: 'Zip',
      specifications: {
        package_id: packageUUID,
      }
    }),
  })
    .then(async (res) => {
      if (res.ok) {
        return res.json()
      }

      let errorMessage = `HTTP error! Status: ${res.status}`

      try {
        // try to extract error message from server
        const errorBody = await res.json()
        errorMessage = errorBody.message
      } catch (ex) {}

      throw new Error(errorMessage)
    })
    .then((json) => {
      if (json.download_blocked || json.over_download_limit) {
        throw new Error('This DCP is no longer available for download.')
      }
      // call zip downloader service
      const link = document.createElement('a');
      link.href = json.zipUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((error) => {
      // cors or network
      console.error(error)

      if (onError) {
        onError(error)
      }
    })
}